import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaClipboardList } from "react-icons/fa6";
import ViewJobRoleRequest from "./view";
import EditJobRoleRequest from "./edit";
import JobRoleRequests from "./index";
import JobPostView from "./jobpostview";
import { MODULE_JOBROLE_REQS } from "variables/constants";

const jobRoleRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Job Role Requests",
		basePath: "job-role-requests",
		mainComponent: <JobRoleRequests />,
	    layout: "/console",	 
		icon: <FaClipboardList className="icon-item"/>,
	    subTitle:"Job Role Requests",
	    viewComponent: <ViewJobRoleRequest />,
	    createComponent: <EditJobRoleRequest />,
	    editComponent: <EditJobRoleRequest />,
		level:3,
		moduleId: MODULE_JOBROLE_REQS,
		submodules: [
			{
				name: "Job Post",
				layout: "/console",
				path: `job-role-requests/:requestId/job-post`,
				component: <JobPostView />,
				level:3,
				moduleId:MODULE_JOBROLE_REQS,
				isMainMenu:false,
			},
		]
	}),
	
]

export default jobRoleRequestRoutes;